<template>
  <div
    class="empty-add-card"
    @click="$_onClick()"
  >
    <i
      v-if="icon"
      class="empty-add-card_icon"
      :class="icon"
    />
    <p
      v-if="title"
      class="empty-add-card_title"
    >
      {{ title }}
    </p>
  </div>
</template>
<script>
export default {
  name: "EmptyAddCard",
  props: {
    title: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "icon-add-circle",
    },
  },
  methods: {
    $_onClick() {
      this.$emit("click");
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/empty-add-card";
</style>